import AdminDebug from './components/Admin/AdminDebug';
import AdminPropertyDashboard from './components/Admin/AdminPropertyDashboard';
import AdminPropertyList from './components/Admin/AdminPropertyList';
import { EmailNotificationDashboard } from './components/Admin/EmailNotifications/EmailNotificationDashboard';
import BuyerNegotiationClauses from './components/BuyerNegotiation/buyernegotiaionclauses';
import ViewContractPage from './components/Contract/contract';
import DownloadContractPage from './components/Contract/Download/DownloadContract';
import { AdminLayout } from './components/Layout/Admin/AdminLayout';
import AgentPropertyDashboard from './components/Layout/Agent/AgentPropertyDashboard';
import AgentSmartRouter from './components/Layout/Agent/AgentSmartRouter';
import { AppLayout } from './components/Layout/App/AppLayout';
import BuyerNegotiateContractPage from './components/Layout/Buyer/Negotiation/BuyerNegotiateContract';
import SellerdashboardPage from './components/Layout/Seller/dashboard/sellerdashboard';
import sellerdashboard from './components/Layout/Seller/dashboard/sellerdashboard';
import SellerNegotiateContractPage from './components/Layout/Seller/Negotiation/SellerNegotiateContract';
import { SellerProductDetails } from './components/Layout/Seller/Product/SellerProductDetails';
import SellerMainPage from './components/Layout/Seller/SellerMainPage';
import AgentDashboard from './components/Layout/SellerAgent/Dashboard/Agentdashboard';
import CounterProposalHistory from './components/Layout/SellerAgent/Negotiation/Component/counterproposalhistory';
import CounterPropose from './components/Layout/SellerAgent/Negotiation/Component/counterpropose';
import NegotiateContractPage from './components/Layout/SellerAgent/Negotiation/NegotiateContract';
import { AgentProductDetailPage } from './components/Layout/SellerAgent/Product/AgentProductDetail';
import QualifiedContractPage from './components/Layout/SellerAgent/QualifiedContractPage';
import PostAgreementDashboard from './components/PostAgreement/PostAgreementDashboard';
import { AdminAgent } from './pages/Admin/AdminAgent';
import { AdminClausesPage } from './pages/Admin/AdminClausesPage';
import AdminDashboard from './pages/Admin/AdminDashboard';
import { AdminDocuments } from './pages/Admin/AdminDocuments';
import { AdminEmail } from './pages/Admin/AdminEmail';
import { AdminFeedback } from './pages/Admin/AdminFeedback';
import { AdminInterestRates } from './pages/Admin/AdminInterestRates';
import { AdminLoanApplicationDetailPage } from './pages/Admin/AdminLoanApplicationDetailPage';
import { AdminLoanChecklistMatricesPage } from './pages/Admin/AdminLoanChecklistMatricesPage';
import { AdminLoanPipelinePage } from './pages/Admin/AdminLoanPipelinePage';
import { AdminPaymentsPage } from './pages/Admin/AdminPaymentsPage';
import { AdminProduct } from './pages/Admin/AdminProduct';
import { AdminProductDetail } from './pages/Admin/AdminProductDetail';
import {
  RedirectAdminUsers,
  RedirectAdminUsersProfile,
} from './pages/Admin/adminRedirects';
import { AdminUser } from './pages/Admin/AdminUser';
import { AdminUserProfilePage } from './pages/Admin/AdminUserProfilePage';
import { AdminUserViewAsPage } from './pages/Admin/AdminUserViewAsPage';
import { AddPropertyPage } from './pages/App/AddPropertyPage';
import { BuyerPostNegotiationSignPage } from './pages/App/BuyerPostNegotiationSignPage';
import { AgentAddContractDetailPage } from './pages/App/ContractDetailAgentPage';
import { SellerAddContractDetailPage } from './pages/App/ContractDetailSellerPage';
import { DealRoomPage } from './pages/App/DealRoomPage';
import { DocumentsVaultPage } from './pages/App/DocumentsVaultPage';
import {
  LoanApplicationRoute,
  LoanDocumentsRoute,
  LoanHubRoute,
  LoanLoanTypeRoute,
  LoanPersonalFinancialStatementRoute,
  LoanQualificationsRoute,
  LoanStartRoute,
  LoanStatusRoute,
} from './pages/App/loan/LoanFlowRoutes';
import {
  RedirectCommercialLoanAppToLoan,
  RedirectCommercialLoanHubToLoan,
  RedirectProfileDocumentsToLoan,
  RedirectProfileLoanStatusToLoan,
  RedirectProfileLoanTypeToLoan,
  RedirectProfileQualificationsToLoan,
} from './pages/App/loan/loanRedirects';
import { LoanEstimatePage } from './pages/App/LoanEstimatePage';
import { OnboardingGoalPage } from './pages/App/onboarding/OnboardingGoalPage';
import { RateWatchOnboardingPage } from './pages/App/onboarding/RateWatchOnboardingPage';
import { ProfilePage } from './pages/App/ProfilePage';
import { PropertiesGridPage } from './pages/App/PropertiesGridPage';
import {
  RedirectBuyerPropertyDashboardToDealRoom,
  RedirectContractDetailToDealRoom,
  RedirectContractToProperties,
  RedirectMainToProperties,
  RedirectQualifiedToProperties,
  RedirectRefinanceIntakeToAddProperty,
  RedirectRefinanceToProperties,
} from './pages/App/propertyRedirects';
import { QualifiedContractAgentPage } from './pages/App/QualifiedContractAgentPage';
import { RefinanceIntakePage } from './pages/App/RefinanceIntakePage';
import { RefinanceSummaryPage } from './pages/App/RefinanceSummaryPage';
import { SellerMainPageWrapper } from './pages/App/SellerMainPage';
import { SellerPostNegotiationSignPage } from './pages/App/SellerPostNegotiationSignPage';
import { DataRequest } from './pages/Basic/DataRequest';
import { LandingPage } from './pages/Basic/LandingPage';
import { PrivacyPolicy } from './pages/Basic/PrivacyPolicy';
import { Support } from './pages/Basic/Support';
import { TermsOfService } from './pages/Basic/TermsOfService';
import AboutPage from './pages/Marketing/AboutPage';
import BlogIndexPage from './pages/Marketing/BlogIndexPage';
import BlogPostPage from './pages/Marketing/BlogPostPage';
import CareersPage from './pages/Marketing/CareersPage';
import DscrPage from './pages/Marketing/DscrPage';
import FixAndFlipPage from './pages/Marketing/FixAndFlipPage';
import LicensingPage from './pages/Marketing/LicensingPage';
import PostSlugRedirect from './pages/Marketing/PostSlugRedirect';
import ServicesPage from './pages/Marketing/ServicesPage';
import Pricing from './pages/Pricing';
import { ChatDemo } from './pages/Test/ChatDemo';
import { HybridInterestRateTest } from './pages/Test/HybridInterestRateTest';
import { VerifyDeleteRequestPage } from './pages/Verify/VerifyDeleteRequestPage';
import { VerifySecurityPage } from './pages/Verify/VerifySecurityPage';
import { VerifySignInPage } from './pages/Verify/VerifySignInPage';

type RoutesType = {
  key: string;
  title: string;
  path: string;
  component: () => JSX.Element;
  children: {
    key: string;
    title: string;
    path: string;
    component: () => JSX.Element | null;
    requireAuth?: boolean;
    requireAdmin?: boolean;
  }[];
};

export const routes: RoutesType[] = [
  {
    key: 'basic-layout',
    title: 'Basic',
    path: '/',
    component: AppLayout,
    children: [
      {
        key: 'landing',
        title: 'Landing',
        path: '/',
        component: LandingPage,
      },
      {
        key: 'blog',
        title: 'Blog',
        path: '/blog',
        component: BlogIndexPage,
      },
      {
        key: 'blog-post',
        title: 'Blog Post',
        path: '/blog/:slug',
        component: BlogPostPage,
      },
      {
        key: 'blog-post-legacy',
        title: 'Blog Post',
        path: '/post/:slug',
        component: PostSlugRedirect,
      },
      {
        key: 'services',
        title: 'Services',
        path: '/services',
        component: ServicesPage,
      },
      {
        key: 'unbeatable-dscr',
        title: 'Unbeatable DSCR',
        path: '/unbeatable-dscr',
        component: DscrPage,
      },
      {
        key: 'unbeatable-fix-and-flip',
        title: 'Unbeatable Fix and Flip',
        path: '/unbeatable-fix-and-flip',
        component: FixAndFlipPage,
      },
      {
        key: 'about-unbeatable',
        title: 'About Unbeatable Loans',
        path: '/about-unbeatable',
        component: AboutPage,
      },
      {
        key: 'licensing',
        title: 'Licensing',
        path: '/licensing',
        component: LicensingPage,
      },
      {
        key: 'careers',
        title: 'Careers',
        path: '/careers',
        component: CareersPage,
      },
      {
        key: 'privacy-policy',
        title: 'Privacy Policy',
        path: '/privacy-policy',
        component: PrivacyPolicy,
      },
      {
        key: 'support',
        title: 'Support',
        path: '/support',
        component: Support,
      },
      {
        key: 'terms-of-service',
        title: 'Terms of Service',
        path: '/terms-of-service',
        component: TermsOfService,
      },
      {
        key: 'data-request',
        title: 'Data Request',
        path: '/data-request',
        component: DataRequest,
      },
      {
        key: 'hybrid-test',
        title: 'Hybrid Interest Rate Test',
        path: '/test/hybrid-rates',
        component: HybridInterestRateTest,
      },
      {
        key: 'chat-demo',
        title: 'AI Chat Demo',
        path: '/test/chat-demo',
        component: ChatDemo,
      },
      {
        key: 'verify-secure',
        title: 'Verify Security',
        path: '/verify/security',
        component: VerifySecurityPage,
      },
      {
        key: 'verify-signin',
        title: 'Verify SignIn',
        path: '/verify/signin',
        component: VerifySignInPage,
      },
      {
        key: 'verify-delete',
        title: 'Verify Delete Request',
        path: '/verify/delete-request',
        component: VerifyDeleteRequestPage,
      },
      {
        key: 'properties',
        title: 'My Properties',
        path: '/properties',
        requireAuth: true,
        component: PropertiesGridPage,
      },
      {
        key: 'onboarding',
        title: 'Onboarding',
        path: '/onboarding',
        requireAuth: true,
        component: OnboardingGoalPage,
      },
      {
        key: 'onboarding-rate-watch',
        title: 'Rate Watch Setup',
        path: '/onboarding/rate-watch',
        requireAuth: true,
        component: RateWatchOnboardingPage,
      },
      {
        key: 'properties-add',
        title: 'Add Property',
        path: '/properties/add',
        requireAuth: true,
        component: AddPropertyPage,
      },
      {
        key: 'properties-deal-room',
        title: 'Deal Room',
        path: '/properties/:propertyId',
        requireAuth: true,
        component: DealRoomPage,
      },
      {
        key: 'properties-deal-room-stage',
        title: 'Deal Room — Stage',
        path: '/properties/:propertyId/stage/:stageNum',
        requireAuth: true,
        component: DealRoomPage,
      },
      {
        key: 'documents-vault',
        title: 'Documents',
        path: '/documents',
        requireAuth: true,
        component: DocumentsVaultPage,
      },
      {
        key: 'main',
        title: 'Main',
        path: '/main',
        requireAuth: true,
        component: RedirectMainToProperties,
      },
      {
        key: 'qualified',
        title: 'Qualified',
        path: '/qualified',
        requireAuth: true,
        component: RedirectQualifiedToProperties,
      },
      {
        key: 'contract',
        title: 'Contract',
        path: '/contract',
        requireAuth: true,
        component: RedirectContractToProperties,
      },
      {
        key: 'profile',
        title: 'Profile',
        path: '/profile',
        requireAuth: true,
        component: ProfilePage,
      },
      {
        key: 'profile-loan-type-redirect',
        title: 'Redirect loan type',
        path: '/profile/loan-type',
        requireAuth: true,
        component: RedirectProfileLoanTypeToLoan,
      },
      {
        key: 'profile-qualifications-redirect',
        title: 'Redirect qualifications',
        path: '/profile/qualifications',
        requireAuth: true,
        component: RedirectProfileQualificationsToLoan,
      },
      {
        key: 'profile-loan-status-redirect',
        title: 'Redirect loan status',
        path: '/profile/loan-status',
        requireAuth: true,
        component: RedirectProfileLoanStatusToLoan,
      },
      {
        key: 'profile-documents-redirect',
        title: 'Redirect documents',
        path: '/profile/documents',
        requireAuth: true,
        component: RedirectProfileDocumentsToLoan,
      },
      {
        key: 'profile-settings',
        title: 'Profile — Settings',
        path: '/profile/settings',
        requireAuth: true,
        component: ProfilePage,
      },
      {
        key: 'pricing',
        title: 'Pricing',
        path: '/pricing',
        component: Pricing,
      },
      {
        key: 'estimate/:productId',
        title: 'Loan Estimate',
        path: '/estimate/:productId',
        requireAuth: true,
        component: LoanEstimatePage,
      },
      {
        key: 'refinance',
        title: 'Refinance',
        path: '/refinance',
        requireAuth: true,
        component: RedirectRefinanceToProperties,
      },
      {
        key: 'loan-hub',
        title: 'Loan',
        path: '/loan',
        requireAuth: true,
        component: LoanHubRoute,
      },
      {
        key: 'loan-loan-type',
        title: 'Loan — Loan type',
        path: '/loan/loan-type',
        requireAuth: true,
        component: LoanLoanTypeRoute,
      },
      {
        key: 'loan-qualifications',
        title: 'Loan — Qualifications',
        path: '/loan/qualifications',
        requireAuth: true,
        component: LoanQualificationsRoute,
      },
      {
        key: 'loan-start',
        title: 'Loan — Start application',
        path: '/loan/start',
        requireAuth: true,
        component: LoanStartRoute,
      },
      {
        key: 'loan-personal-financial-statement',
        title: 'Loan — Personal Financial Statement',
        path: '/loan/personal-financial-statement',
        requireAuth: true,
        component: LoanPersonalFinancialStatementRoute,
      },
      {
        key: 'loan-loan-status',
        title: 'Loan — Loan status',
        path: '/loan/loan-status',
        requireAuth: true,
        component: LoanStatusRoute,
      },
      {
        key: 'loan-documents',
        title: 'Loan — Documents',
        path: '/loan/documents',
        requireAuth: true,
        component: LoanDocumentsRoute,
      },
      {
        key: 'loan-application',
        title: 'Loan application file',
        path: '/loan/:applicationId',
        requireAuth: true,
        component: LoanApplicationRoute,
      },
      {
        key: 'commercial-loan-hub-redirect',
        title: 'Redirect commercial loan hub',
        path: '/commercial-loan',
        requireAuth: true,
        component: RedirectCommercialLoanHubToLoan,
      },
      {
        key: 'commercial-loan-app-redirect',
        title: 'Redirect commercial loan app',
        path: '/commercial-loan/:applicationId',
        requireAuth: true,
        component: RedirectCommercialLoanAppToLoan,
      },
      {
        key: 'refinance-intake',
        title: 'Refinance Intake',
        path: '/refinance/intake',
        requireAuth: true,
        component: RedirectRefinanceIntakeToAddProperty,
      },
      {
        key: 'refinance-intake-edit',
        title: 'Refinance Intake',
        path: '/refinance/intake/:productId',
        requireAuth: true,
        component: RefinanceIntakePage,
      },
      {
        key: 'refinance-summary',
        title: 'Refinance Summary',
        path: '/refinance/summary',
        requireAuth: true,
        component: RefinanceSummaryPage,
      },
      {
        key: 'refinance-summary-product',
        title: 'Refinance Summary',
        path: '/refinance/summary/:productId',
        requireAuth: true,
        component: RefinanceSummaryPage,
      },
      {
        key: 'contract/:productId',
        title: 'Contract Detail',
        path: '/contract/:productId',
        requireAuth: true,
        component: RedirectContractDetailToDealRoom,
      },
      {
        key: 'view-contract/:contractId',
        title: 'Contract Detail',
        path: '/view-contract/:contractId',
        requireAuth: true,
        component: ViewContractPage,
      },
      {
        key: 'contract/negotiation-clauses/:contractId',
        title: 'Buyer Negotiation Clauses',
        path: '/contract/negotiation-clauses/:contractId',
        requireAuth: true,
        component: BuyerNegotiationClauses,
      },
      {
        key: 'contract/download/:contractId',
        title: 'Download Contract',
        path: '/contract/download/:contractId',
        requireAuth: true,
        component: DownloadContractPage,
      },
      {
        key: 'buyer/negotiate/:contractId',
        title: 'Buyer Negotiation',
        path: '/buyer/negotiate/:contractId',
        requireAuth: true,
        component: BuyerNegotiateContractPage,
      },
      {
        key: 'buyer/contract/:contractId/sign',
        title: 'Sign Contract',
        path: '/buyer/contract/:contractId/sign',
        requireAuth: true,
        component: BuyerPostNegotiationSignPage as any,
      },
      {
        key: 'buyer/property-dashboard/:contractId',
        title: 'Buyer Post-Agreement Dashboard',
        path: '/buyer/property-dashboard/:contractId',
        requireAuth: true,
        component: RedirectBuyerPropertyDashboardToDealRoom,
      },
      // Agent Routes
      {
        key: 'agent/smart-router/:agentId',
        title: 'Agent Smart Router',
        path: '/agent/smart-router/:agentId',
        requireAuth: true,
        component: AgentSmartRouter,
      },
      {
        key: 'agent/dashboard/:agentId',
        title: 'Agent Dashboard',
        path: '/agent/dashboard/:agentId',
        requireAuth: true,
        component: AgentDashboard,
      },
      {
        key: 'contract/agent/:uid',
        title: 'Contract Agent Detail',
        path: '/contract/agent/:uid',
        component: AgentAddContractDetailPage,
      },
      {
        key: 'agent/qualified-contract',
        title: 'Qualified Contract',
        path: '/agent/qualified-contract/:agentId',
        requireAuth: true,
        component: QualifiedContractAgentPage,
      },
      {
        key: 'agent/product/:productId',
        title: 'Agent Product Detail',
        path: '/agent/product/:productId',
        requireAuth: true,
        component: AgentProductDetailPage,
      },
      {
        key: 'contract/agent/:uid',
        title: 'Agent Contract',
        path: '/agent/contract/:uid',
        requireAuth: true,
        component: NegotiateContractPage,
      },
      {
        key: 'agent/property-dashboard/:contractId',
        title: 'Agent Property Dashboard',
        path: '/agent/property-dashboard/:contractId',
        requireAuth: true,
        component: AgentPropertyDashboard,
      },
      {
        key: 'agent/counter-proposal/:contractId',
        title: 'Agent Counter Proposal',
        path: '/agent/counter-proposal/:contractId',
        requireAuth: true,
        component: CounterPropose,
      },
      {
        key: 'contract/counter-proposal-history/:contractId',
        title: 'Agent Counter Proposal History',
        path: '/contract/counter-proposal-history/:contractId',
        requireAuth: true,
        component: CounterProposalHistory,
      },
      // Seller Routes
      {
        key: 'seller/main',
        title: 'Seller Main',
        path: '/seller/main/:sellerId',
        requireAuth: true,
        component: SellerMainPageWrapper,
      },
      {
        key: 'seller/dashboard',
        title: 'Seller Dashboard',
        path: '/seller/dashboard/:sellerId',
        requireAuth: true,
        component: SellerdashboardPage,
      },
      {
        key: 'seller/product/:productId',
        title: 'Seller Product Details',
        path: '/seller/product/:productId',
        requireAuth: true,
        component: SellerProductDetails,
      },
      {
        key: 'seller/add-detail/:contractId',
        title: 'Contract Seller Detail',
        path: '/seller/add-detail/:contractId',
        requireAuth: true,
        component: SellerAddContractDetailPage,
      },
      {
        key: 'seller/negotiate/:contractId',
        title: 'Seller Negotiation',
        path: '/seller/negotiate/:contractId',
        requireAuth: true,
        component: SellerNegotiateContractPage,
      },
      {
        key: 'seller/contract/:contractId/sign',
        title: 'Sign Contract',
        path: '/seller/contract/:contractId/sign',
        requireAuth: true,
        component: SellerPostNegotiationSignPage as any,
      },
      {
        key: 'seller/property-dashboard/:contractId',
        title: 'Seller Post-Agreement Dashboard',
        path: '/seller/property-dashboard/:contractId',
        requireAuth: true,
        component: PostAgreementDashboard,
      },
    ],
  },
  // Admin Routes
  {
    key: 'admin-layout',
    title: 'Admin',
    path: '/admin',
    component: AdminLayout,
    children: [
      {
        key: 'admin-debug',
        title: 'Admin Debug',
        path: '/admin/debug',
        requireAuth: true,
        requireAdmin: false,
        component: AdminDebug as () => JSX.Element,
      },
      {
        key: 'admin-dashboard',
        title: 'Admin Dashboard',
        path: '/admin',
        requireAuth: true,
        requireAdmin: true,
        component: AdminDashboard as () => JSX.Element,
      },
      {
        key: 'admin-user',
        title: 'Users',
        path: '/admin/user',
        requireAuth: true,
        requireAdmin: true,
        component: AdminUser,
      },
      {
        key: 'admin-user-profile',
        title: 'Person',
        path: '/admin/user/:userId',
        requireAuth: true,
        requireAdmin: true,
        component: AdminUserProfilePage,
      },
      {
        key: 'admin-user-view-as',
        title: 'View as user',
        path: '/admin/user/:userId/view-as',
        requireAuth: true,
        requireAdmin: true,
        component: AdminUserViewAsPage,
      },
      {
        key: 'admin-users-redirect',
        title: 'Users',
        path: '/admin/users',
        requireAuth: true,
        requireAdmin: true,
        component: RedirectAdminUsers,
      },
      {
        key: 'admin-users-profile-redirect',
        title: 'Person',
        path: '/admin/users/:userId',
        requireAuth: true,
        requireAdmin: true,
        component: RedirectAdminUsersProfile,
      },
      {
        key: 'admin-documents',
        title: 'Documents',
        path: '/admin/documents',
        requireAuth: true,
        requireAdmin: true,
        component: AdminDocuments,
      },

      {
        key: 'admin-agent',
        title: 'Agents',
        path: '/admin/agent',
        requireAuth: true,
        requireAdmin: true,
        component: AdminAgent,
      },
      {
        key: 'admin-email',
        title: 'Emails',
        path: '/admin/email',
        requireAuth: true,
        requireAdmin: true,
        component: AdminEmail,
      },
      {
        key: 'admin-email-notifications',
        title: 'Email Notifications',
        path: '/admin/email/notifications',
        requireAuth: true,
        requireAdmin: true,
        component: EmailNotificationDashboard,
      },
      {
        key: 'admin-product',
        title: 'Estimates',
        path: '/admin/product',
        requireAuth: true,
        requireAdmin: true,
        component: AdminProduct,
      },
      {
        key: 'admin-product-detail',
        title: 'Estimate Detail',
        path: '/admin/product/:productId',
        requireAuth: true,
        requireAdmin: true,
        component: AdminProductDetail,
      },
      {
        key: 'admin-messenger',
        title: 'Messenger',
        path: '/admin/messenger',
        requireAuth: true,
        requireAdmin: true,
        component: AdminFeedback,
      },
      {
        key: 'admin-feedback',
        title: 'Messenger',
        path: '/admin/feedback',
        requireAuth: true,
        requireAdmin: true,
        component: AdminFeedback,
      },
      {
        key: 'admin-interest-rates',
        title: 'Rates',
        path: '/admin/interest-rates',
        requireAuth: true,
        requireAdmin: true,
        component: AdminInterestRates,
      },
      {
        key: 'admin-property-list',
        title: 'Contracts',
        path: '/admin/properties',
        requireAuth: true,
        requireAdmin: true,
        component: AdminPropertyList as () => JSX.Element,
      },
      {
        key: 'admin-property-dashboard',
        title: 'Contract Dashboard',
        path: '/admin/property/:contractId',
        requireAuth: true,
        requireAdmin: true,
        component: AdminPropertyDashboard as () => JSX.Element,
      },
      {
        key: 'admin-loan-pipeline',
        title: 'Loan Files',
        path: '/admin/loan-pipeline',
        requireAuth: true,
        requireAdmin: true,
        component: AdminLoanPipelinePage,
      },
      {
        key: 'admin-loan-checklist-matrices',
        title: 'Checklists',
        path: '/admin/loan-checklist-matrices',
        requireAuth: true,
        requireAdmin: true,
        component: AdminLoanChecklistMatricesPage,
      },
      {
        key: 'admin-clauses',
        title: 'Clauses',
        path: '/admin/clauses',
        requireAuth: true,
        requireAdmin: true,
        component: AdminClausesPage,
      },
      {
        key: 'admin-payments',
        title: 'Payments',
        path: '/admin/payments',
        requireAuth: true,
        requireAdmin: true,
        component: AdminPaymentsPage,
      },
      {
        key: 'admin-loan-detail',
        title: 'Loan application detail',
        path: '/admin/loan-pipeline/:applicationId',
        requireAuth: true,
        requireAdmin: true,
        component: AdminLoanApplicationDetailPage,
      },
    ],
  },
];
